<template>
  <div>
    <v-layout row>
      <h2 class="besetblue--text ml-2 mt-2"> besea </h2>
    </v-layout>
    <v-container>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-img
          class="white--text"
          height="200px"
          :src="require('@/app/assets/images/plant04.jpeg')"
          >
           <v-container fill-height fluid>
             <v-layout fill-height>
               <v-flex xs12 align-end flexbox>
                 <span class="headline"> validate </span>
               </v-flex>
             </v-layout>
           </v-container>
         </v-img>
         <v-layout row>
         <v-spacer/>
           <div class="caption mr-2"> Nature. </div>
         </v-layout>
         <v-card-title primary-title>
           <div>
             <h3 class="headline mb-0 besetblue--text">Validate Email</h3>
             <blockquote class="blockquote">
               Check your email to validate your membership.
             </blockquote>
           </div>
        </v-card-title>
        <v-layout row>
          <v-spacer/>
          <v-btn flat color="besetblue" :to="'/signin'">
            <v-icon left> account_circle </v-icon>
            ready to sign in
           </v-btn>
         </v-layout>
       </v-card>
      </v-flex>
    </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({})
};
</script>
